import styled from 'styled-components'

export const CartIconContainer = styled.div`
    width: 45px;
    height: 45px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
`

export const ShoppingIconWrapper = styled.div`
    width: 32px;
    height: 32px;
`

export const CartIconCount = styled.span`
    position: absolute;
    color: #fff;
    background: #F8B0BB;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    right: 4px;
    top: 22px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
`

